import { render, staticRenderFns } from "./OrderCounterCard.vue?vue&type=template&id=23b5ecb4&scoped=true&lang=pug"
import script from "./OrderCounterCard.vue?vue&type=script&lang=js"
export * from "./OrderCounterCard.vue?vue&type=script&lang=js"
import style0 from "./OrderCounterCard.vue?vue&type=style&index=0&id=23b5ecb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b5ecb4",
  null
  
)

export default component.exports